export default "__VITE_ASSET__C3gW8PeD__"